import { Monitoring_Notification, ServiceConfig } from 'features/quote/components/type'
import {
  ClaimStatus,
  CommunicationMediumEnum,
  NotificationMessages,
  ServicesAssessmentsEnum,
  ServicesEnum,
  ThreatMonitoringStartDate,
  TimeZone,
  ComingSoonServicesEnum,
} from 'utils/enum'

export const NODE_ENV = process.env.REACT_APP_NODE_ENV
export const API_URL = process.env.REACT_APP_API_URL
export const POLY_EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL
export const PLOYGON_AMOY_RPC_URL = process.env.REACT_APP_PLOYGON_AMOY_RPC_URL
export const Contract_Address = process.env.REACT_APP_CONTRACT_ADDRESS
export const Chain_Id = Number(process.env.REACT_APP_CHAIN_ID)
export const StripPublicKey = String(process.env.REACT_APP_API_STRIPE_PAYEMENT)
export const AffiliateID = process.env.REACT_APP_AFFILIATE_ID as string
export const MicrosoftCallback = process.env.REACT_APP_MICROSOFT_CALLBACK as string
// BreachRx sells CIRM as its own service rather than the Secure Score integration
// it runs on, and that applies to every warranty they write — not just the first
// one — so the carrier is what we key off. Overridable per environment because
// the insurance company id differs between databases.
export const BREACHRX_CIRM_COMPANY_ID = Number(process.env.REACT_APP_BREACHRX_COMPANY_ID) || 32
export const BREACHRX_CIRM_SERVICE_NAME = 'BreachRx API Connectivity'
export const BREACHRX_CIRM_BUTTON_LABEL = 'Direct BreachRx API coming soon'
export const routes = {
  // general
  home: '/',
  about: '/about',
  security: '/security',
  support: '/support',
  warranty: '/warranty',
  blog: '/blog',
  blogCatagory: '/blog/:catagory',
  blogDetail: '/blog/:catagory/:detail/:id',
  stripPayment: '/stripe-payment',
  //quote
  qoute: 'get-a-quote', //first time login
  quoteSupportForm: '/get-a-quote-support',
  quoteSentinelOne: '/get-a-quote-sentinel-one',

  //affiliate id base user by subadmin carrier
  customLanding: '/box-carrier',
  breachRX: '/affiliate/breachRX',

  // auth
  login: '/auth/login',
  register: '/auth/register',
  reset: '/auth/reset-password',
  forgot: '/auth/forgot-password',
  sentinel: '/misc/sentinel-one',
  sentinelNew: '/misc/sentinel-one/new',
  accountVerification: '/auth/account-verification',
  // dashboard
  dashboard: '/app/incidents',
  incidents: '/app/incidents',
  insurancePolicy: '/app/insurance',
  editProfile: '/app/profile/edit',
  changePass: '/app/profile/change',
  assessments: '/app/profile/assessments',
  // secure score microsoft
  assessmentsCallback: '/app/profile/assessments/callback',
  secureScore: '/app/secure-score-summary',

  insurance: '/app/insurance',
  insuranceForm: '/Insurance-form',
  resendVerificationLink: '/auth/resend-verification-link',
  inventory: '/app/inventory',
}
export const steps = ['Incident Detected', 'Verifiying Incident', 'Initiate Claim', 'Benefits Confirmation', 'User Confirmation ', 'Block Creation', ' Resolved']
export const ClaimStatusList = [
  {
    label: ClaimStatus.ALL,
    value: '',
  },
  {
    label: ClaimStatus.APPLICABLE,
    value: ClaimStatus.APPLICABLE,
  },
  {
    label: ClaimStatus.NOT_APPLICABLE,
    value: ClaimStatus.NOT_APPLICABLE,
  },
  {
    label: ClaimStatus.CLAIM_RAISED,
    value: ClaimStatus.CLAIM_RAISED,
  },
  {
    label: ClaimStatus.APPROVED,
    value: ClaimStatus.APPROVED,
  },
  {
    label: ClaimStatus.DISAPPROVED,
    value: ClaimStatus.DISAPPROVED,
  },
  {
    label: ClaimStatus.ACCEPTED,
    value: ClaimStatus.ACCEPTED,
  },
  {
    label: ClaimStatus.REJECTED,
    value: ClaimStatus.REJECTED,
  },
  {
    label: ClaimStatus.RE_EVALUATE,
    value: ClaimStatus.RE_EVALUATE,
  },
]
export const startDates = [
  {
    label: 'As soon as possible',
    value: ThreatMonitoringStartDate.ASAP,
  },
  {
    label: 'Withing a month or two',
    value: ThreatMonitoringStartDate.IN_MONTH,
  },
  {
    label: '2-4 months',
    value: ThreatMonitoringStartDate.TWO_TO_FOUR_MONTHS,
  },
  {
    label: 'More than 4 months in advance',
    value: ThreatMonitoringStartDate.MORE_THAN_4_Months,
  },
]
export const commMediumList = [
  {
    label: CommunicationMediumEnum.PHONENUMBER,
    value: CommunicationMediumEnum.PHONENUMBER,
  },
  {
    label: CommunicationMediumEnum.EMAIL,
    value: CommunicationMediumEnum.EMAIL,
  },
  {
    label: CommunicationMediumEnum.WHATSAPP,
    value: CommunicationMediumEnum.WHATSAPP,
  },
]

export const TimeList = [
  {
    label: TimeZone.MORNING,
    value: TimeZone.MORNING_VALUE,
  },
  {
    label: TimeZone.AFTERNOON,
    value: TimeZone.AFTERNOON_VALUE,
  },
  {
    label: TimeZone.EVENING,
    value: TimeZone.EVENING_VALUE,
  },
]

//TODO:In start client want all the services handling,and now only three of them is integrated
// right now the all the catageorization and classfication done in FE
// Next scope all this will be done from BE
//was handle in generic way,which is now conflict so divvide into 2 group
export const serviceLableAssessments: { [key in ServicesEnum | string]: string } = {
  [ServicesEnum.COVE_DATA]: 'Backup',
  [ServicesEnum.EDR]: 'EDR',
  [ServicesEnum.N_SIGHT_PATCH]: 'Patch Management',
  [ServicesEnum.N_SIGHT_AV]: 'Anti-Virus',
  [ServicesEnum.N_CENTERAL]: 'Patch Management',
  [ServicesEnum.MICROSOFT_SECURE_SCORE]: 'Microsoft Graph',
  [ServicesEnum.WINDOWS_DEFENDER]: 'Microsoft Security Center',
}

export const serviceArrayAssessment = [
  ServicesEnum.EDR,
  ServicesEnum.COVE_DATA,
  ServicesEnum.N_SIGHT_AV,
  ServicesEnum.N_SIGHT_PATCH,
  ServicesEnum.N_CENTERAL,
  ServicesEnum.MICROSOFT_SECURE_SCORE,
  ServicesEnum.WINDOWS_DEFENDER,
]

export const serviceArray = [ServicesEnum.EDR, ServicesEnum.COVE_DATA, ServicesEnum.N_SIGHT_PATCH]

export const serviceConfig: ServiceConfig = {
  [ServicesEnum.EDR]: {
    label: 'EDR',
    title: 'How to get started with EDR',
    youtubeLink: 'https://www.youtube.com/embed/sTwJ7Cu0w-g',
  },
  [ServicesEnum.COVE_DATA]: {
    label: 'Cove',
    title: 'How to get started with Cove',
    youtubeLink: 'https://www.youtube.com/embed/AtDAOfP8Wn8',
  },
  [ServicesEnum.N_SIGHT_PATCH]: {
    label: 'N Sight Patch Management',
    title: 'How to get started with N-Sight-Patch Management',
    youtubeLink: 'https://www.youtube.com/embed/vWgwv6R7-ZI',
  },
  [ServicesEnum.N_SIGHT_AV]: {
    label: 'N-Sight AV',
    title: 'How to get started with N-Sight AV Management',
    youtubeLink: 'https://www.youtube.com/embed/x4K4UAuP_gc',
  },
  [ServicesEnum.N_CENTERAL]: {
    label: 'N-Central',
    title: 'How to get started with N-Central',
    youtubeLink: 'https://www.youtube.com/embed/x4K4UAuP_gc',
  },
  [ServicesEnum.MICROSOFT_SECURE_SCORE]: {
    label: 'Microsoft Secure Score',
    title: 'How to get started with Microsoft Secure Score',
    youtubeLink: 'https://www.youtube.com/embed/gWw0fS3DA0A',
  },
  [ServicesAssessmentsEnum.VEEM]: {
    label: '',
    title: '',
    youtubeLink: '',
  },
  [ServicesEnum.WINDOWS_DEFENDER]: {
    label: '',
    title: '',
    youtubeLink: '',
  },
}

export const Monitoring_Services_Notification: Monitoring_Notification = {
  [ServicesEnum.EDR]: {
    Notification: NotificationMessages.SENTINEL_KEY,
  },
  [ServicesEnum.N_SIGHT_PATCH]: {
    Notification: NotificationMessages.Patch_N_Sight,
  },
  [ServicesEnum.COVE_DATA]: {
    Notification: NotificationMessages.COVE,
  },
  [ServicesEnum.N_SIGHT_AV]: {
    Notification: '',
  },
  [ServicesEnum.MICROSOFT_SECURE_SCORE]: {
    Notification: NotificationMessages.MICROSOFT_SECURE_SCORE,
  },
  [ServicesEnum.WINDOWS_DEFENDER]: {
    Notification: NotificationMessages.WINDOWS_DEFENDER,
  },
  [ServicesEnum.N_CENTERAL]: {
    Notification: '',
  },
}
//adding empty space in array from backend the id are not consistent
export const IncidentArray = ['Sentinel One', 'Cove Data Backup', 'N Sight AV', 'N Sight Patch', '', 'Microsoft Office 365', 'Windows Defender']
export const comingSoonServices = [ComingSoonServicesEnum.Crowd_Strike, ComingSoonServicesEnum.Bitdefender_Gravity, ComingSoonServicesEnum.Malware_Bytes]
export const galaxyImageStaticDataArray = [
  {
    Orgc: {
      id: '3',
      name: 'CIRCL',
      uuid: '55f6ea5e-2c60-40e5-964f-47a8950d210f',
      local: false,
    },
    Tag: [
      {
        local: false,
        id: '7',
        name: 'tlp:white',
        colour: '#ffffff',
        numerical_value: null,
      },
      {
        local: false,
        id: '8',
        name: 'osint:source-type="blog-post"',
        colour: '#00223b',
        numerical_value: null,
      },
      {
        local: false,
        id: '148',
        name: 'misp-galaxy:ransomware="WannaCry"',
        colour: '#0088cc',
        numerical_value: null,
      },
    ],
  },

  {
    Orgc: {
      id: '31',
      name: 'abuse.ch',
      uuid: '9b086132-8588-49ed-97fd-8578a777822c',
      local: false,
    },
    Tag: [
      {
        id: '1437',
        name: 'exe',
        colour: '#D984D4',
        numerical_value: null,
        is_galaxy: false,
        local: false,
      },
      {
        id: '3573',
        name: 'WannaCry',
        colour: '#130D20',
        numerical_value: null,
        is_galaxy: false,
        local: false,
      },
      {
        id: '5',
        name: 'type:OSINT',
        colour: '#004646',
        numerical_value: null,
        inherited: 1,
      },
      {
        id: '7',
        name: 'tlp:white',
        colour: '#ffffff',
        numerical_value: null,
        inherited: 1,
      },
    ],
  },
]

export const SectorList = [
  { label: 'Accounting', value: 'accounting' },
  { label: 'Aerospace/Defense', value: 'aerospace-defense' },
  { label: 'Airlines/Aviation', value: 'airlines-aviation' },
  { label: 'Alternative Dispute Resolution', value: 'alternative-dispute-resolution' },
  { label: 'Alternative Medicine', value: 'alternative-medicine' },
  { label: 'Animation', value: 'animation' },
  { label: 'Apparel & Fashion', value: 'apparel-fashion' },
  { label: 'Architecture & Planning', value: 'architecture-planning' },
  { label: 'Arts and Crafts', value: 'arts-and-crafts' },
  { label: 'Automotive', value: 'automotive' },
  { label: 'Aviation & Aerospace', value: 'aviation-aerospace' },
  { label: 'Banking', value: 'banking' },
  { label: 'Biotechnology', value: 'biotechnology' },
  { label: 'Broadcast Media', value: 'broadcast-media' },
  { label: 'Building Materials', value: 'building-materials' },
  { label: 'Business Services', value: 'business-services' },
  { label: 'Business Supplies and Equipment', value: 'business-supplies-equipment' },
  { label: 'Capital Markets', value: 'capital-markets' },
  { label: 'Chemicals', value: 'chemicals' },
  { label: 'Civic & Social Organization', value: 'civic-social-organization' },
  { label: 'Civil Engineering', value: 'civil-engineering' },
  { label: 'Commercial Real Estate', value: 'commercial-real-estate' },
  { label: 'Computer & Network Security', value: 'computer-network-security' },
  { label: 'Computer Games', value: 'computer-games' },
  { label: 'Computer Hardware', value: 'computer-hardware' },
  { label: 'Computer Networking', value: 'computer-networking' },
  { label: 'Computer Software', value: 'computer-software' },
  { label: 'Construction', value: 'construction' },
  { label: 'Consumer Electronics', value: 'consumer-electronics' },
  { label: 'Consumer Goods', value: 'consumer-goods' },
  { label: 'Consumer Services', value: 'consumer-services' },
  { label: 'Cosmetics', value: 'cosmetics' },
  { label: 'Credit Union', value: 'credit-union' },
  { label: 'Dairy', value: 'dairy' },
  { label: 'Defense & Space', value: 'defense-space' },
  { label: 'Design', value: 'design' },
  { label: 'E-Learning', value: 'e-learning' },
  { label: 'Education', value: 'education' },
  { label: 'Education Management', value: 'education-management' },
  { label: 'Electrical/Electronic Manufacturing', value: 'electrical-electronic-manufacturing' },
  { label: 'Energy/Resources', value: 'energy-resources' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Environmental Services', value: 'environmental-services' },
  { label: 'Events Services', value: 'events-services' },
  { label: 'Executive Office', value: 'executive-office' },
  { label: 'Facilities Services', value: 'facilities-services' },
  { label: 'Farming', value: 'farming' },
  { label: 'Finance', value: 'finance' },
  { label: 'Financial Services', value: 'financial-services' },
  { label: 'Fine Art', value: 'fine-art' },
  { label: 'Fishery', value: 'fishery' },
  { label: 'Food & Beverages', value: 'food-beverages' },
  { label: 'Food Production', value: 'food-production' },
  { label: 'Fund-Raising', value: 'fund-raising' },
  { label: 'Furniture', value: 'furniture' },
  { label: 'Gambling & Casinos', value: 'gambling-casinos' },
  { label: 'Glass, Ceramics & Concrete', value: 'glass-ceramics-concrete' },
  { label: 'Government Administration', value: 'government-administration' },
  { label: 'Government Relations', value: 'government-relations' },
  { label: 'Government/Politics', value: 'government-politics' },
  { label: 'Graphic Design', value: 'graphic-design' },
  { label: 'Health, Wellness and Fitness', value: 'health-wellness-fitness' },
  { label: 'Healthcare/Wellness', value: 'healthcare-wellness' },
  { label: 'Higher Education', value: 'higher-education' },
  { label: 'Hospital & Health Care', value: 'hospital-health-care' },
  { label: 'Hospitality', value: 'hospitality' },
  { label: 'Human Resources', value: 'human-resources' },
  { label: 'Import and Export', value: 'import-export' },
  { label: 'Individual & Family Services', value: 'individual-family-services' },
  { label: 'Industrial Automation', value: 'industrial-automation' },
  { label: 'Information Services', value: 'information-services' },
  { label: 'Information Technology and Services', value: 'information-technology-services' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'International Affairs', value: 'international-affairs' },
  { label: 'International Trade and Development', value: 'international-trade-development' },
  { label: 'Internet', value: 'internet' },
  { label: 'Investment Banking', value: 'investment-banking' },
  { label: 'Investment Management', value: 'investment-management' },
  { label: 'Judiciary', value: 'judiciary' },
  { label: 'Law Enforcement', value: 'law-enforcement' },
  { label: 'Law Practice', value: 'law-practice' },
  { label: 'Legal', value: 'legal' },
  { label: 'Legal Services', value: 'legal-services' },
  { label: 'Legislative Office', value: 'legislative-office' },
  { label: 'Leisure, Travel & Tourism', value: 'leisure-travel-tourism' },
  { label: 'Libraries', value: 'libraries' },
  { label: 'Logistics and Supply Chain', value: 'logistics-supply-chain' },
  { label: 'Luxury Goods & Jewelry', value: 'luxury-goods-jewelry' },
  { label: 'Machinery', value: 'machinery' },
  { label: 'Management Consulting', value: 'management-consulting' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Maritime', value: 'maritime' },
  { label: 'Market Research', value: 'market-research' },
  { label: 'Marketing and Advertising', value: 'marketing-advertising' },
  { label: 'Mechanical or Industrial Engineering', value: 'mechanical-industrial-engineering' },
  { label: 'Media Production', value: 'media-production' },
  { label: 'Media/Entertainment', value: 'media-entertainment' },
  { label: 'Medical Devices', value: 'medical-devices' },
  { label: 'Medical Practice', value: 'medical-practice' },
  { label: 'Mental Health Care', value: 'mental-health-care' },
  { label: 'Military', value: 'military' },
  { label: 'Mining & Metals', value: 'mining-metals' },
  { label: 'Motion Pictures and Film', value: 'motion-pictures-film' },
  { label: 'Museums and Institutions', value: 'museums-institutions' },
  { label: 'Music', value: 'music' },
  { label: 'Nanotechnology', value: 'nanotechnology' },
  { label: 'Newspapers', value: 'newspapers' },
  { label: 'Non-Profit Organization Management', value: 'non-profit-organization-management' },
  { label: 'Nonprofit/NGO', value: 'nonprofit-ngo' },
  { label: 'Oil & Energy', value: 'oil-energy' },
  { label: 'Online Media', value: 'online-media' },
  { label: 'Outsourcing/Offshoring', value: 'outsourcing-offshoring' },
  { label: 'Package/Freight Delivery', value: 'package-freight-delivery' },
  { label: 'Packaging and Containers', value: 'packaging-containers' },
  { label: 'Paper & Forest Products', value: 'paper-forest-products' },
  { label: 'Performing Arts', value: 'performing-arts' },
  { label: 'Pharmaceuticals', value: 'pharmaceuticals' },
  { label: 'Philanthropy', value: 'philanthropy' },
  { label: 'Photography', value: 'photography' },
  { label: 'Plastics', value: 'Plastics' },
  { label: 'Political Organization', value: 'Political Organization' },
  { label: 'Primary/Secondary Education', value: 'Primary/Secondary Education' },
  { label: 'Printing', value: 'Printing' },
  { label: 'Professional Training & Coaching', value: 'Professional Training & Coaching' },
  { label: 'Program Development', value: 'Program Development' },
  { label: 'Public Policy', value: 'Public Policy' },
  { label: 'Public Relations and Communications', value: 'Public Relations and Communications' },
  { label: 'Public Safety', value: 'Public Safety' },
  { label: 'Publishing', value: 'Publishing' },
  { label: 'Railroad Manufacture', value: 'Railroad Manufacture' },
  { label: 'Ranching', value: 'Ranching' },
  { label: 'Real Estate', value: 'Real Estate' },
  { label: 'Recreational Facilities and Services', value: 'Recreational Facilities and Services' },
  { label: 'Religious Institutions', value: 'Religious Institutions' },
  { label: 'Renewables & Environment', value: 'Renewables & Environment' },
  { label: 'Research', value: 'Research' },
  { label: 'Restaurants', value: 'Restaurants' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Security and Investigations', value: 'Security and Investigations' },
  { label: 'Semiconductors', value: 'Semiconductors' },
  { label: 'Shipbuilding', value: 'Shipbuilding' },
  { label: 'Sporting Goods', value: 'Sporting Goods' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
  { label: 'Supermarkets', value: 'Supermarkets' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Telecommunications', value: 'Telecommunications' },
  { label: 'Textiles', value: 'Textiles' },
  { label: 'Think Tanks', value: 'Think Tanks' },
  { label: 'Tobacco', value: 'Tobacco' },
  { label: 'Tourism/Hospitality', value: 'Tourism/Hospitality' },
  { label: 'Translation and Localization', value: 'Translation and Localization' },
  { label: 'Transportation', value: 'Transportation' },
  { label: 'Utilities', value: 'Utilities' },
  { label: 'Venture Capital & Private Equity', value: 'Venture Capital & Private Equity' },
  { label: 'Veterinary', value: 'Veterinary' },
  { label: 'Warehousing', value: 'Warehousing' },
  { label: 'Wholesale', value: 'Wholesale' },
  { label: 'Wine and Spirits', value: 'Wine and Spirits' },
  { label: 'Wireless', value: 'Wireless' },
  { label: 'Writing and Editing', value: 'Writing and Editing' },
]
export const Period = {
  month: 'MONTHLY',
  annual: 'YEARLY',
}
